import { render, staticRenderFns } from "./ContentSSR.vue?vue&type=template&id=d7672432&scoped=true&"
import script from "./ContentSSR.vue?vue&type=script&lang=ts&"
export * from "./ContentSSR.vue?vue&type=script&lang=ts&"
import style0 from "./ContentSSR.vue?vue&type=style&index=0&id=d7672432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7672432",
  null
  
)

export default component.exports